import React, { useState ,useEffect} from "react";
import CartManuallyAddPart from "./CartManuallyAddPart";
import ClearCart from "../ClearCart";
import CartList from "./CartList";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import { useCartStore } from "src/hooks/cart";
import FadeInOut from "../../../component/Global/FadeInOut";
import ShowAlert from "src/component/Global/ShowAlert";
import { useDOMAttachToSystemStore } from "src/hooks/domAttachToSystem";
import { useProductStore } from "src/hooks/product";
import Constants from "src/helper/Constants";
import AxiosIndicatorRunTimeLoader from "src/component/Global/AxiosIndicatorRunTimeLoader";
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { isArray } from "underscore";

const CartLeftContent = (props) => {
  const [{ CART_DATA, VALIDATE_CART }, {}, {}] = useCartStore();
  const [__check] = useAxiosIndicatorCheck();
  const [{}, { system_alert_indicator }, {}] = useDOMAttachToSystemStore();
  const [{ productList }, {}, {}] = useProductStore();
  const {
    ACCOUNTINACTIVE,
    INTERNALUSER,
    INVALIDSUPPLIER,
    RESTRICTEDCOUNTRY,
    CARTEOLOBSOLETE,
    PRODUCT_UNAVAILABLE
  } = Constants;
  const [isErrorEvent, setErrorEvent] = useState(true);
  useEffect(() => {
    VALIDATE_CART?.validation &&
      Object.keys(VALIDATE_CART?.validation)?.length > 0 &&
      Object.entries(VALIDATE_CART?.validation).map((obj) => {
        if (
          ![
            ACCOUNTINACTIVE,
            INTERNALUSER,
            RESTRICTEDCOUNTRY
          ].includes(obj[0]) &&
          CART_DATA &&
          Object.entries(CART_DATA)?.length > 0
        ) {
          system_alert_indicator({
            name: obj[0],
            message: obj[1],
            type: "danger",
            isDisplay: false,
            isDisplayIcon: true,
            data:
              obj[0] === INVALIDSUPPLIER
                ? VALIDATE_CART?.cartItems
                    ?.filter((ele) => ele?.isSupplierRestricted === true)
                    .map((ele) => ele?.erpMfrPartNumber)
                : null,
          });
          if (isErrorEvent) {
            errorDetailsEvent(obj);
            setErrorEvent(false);
          }
        }
      });

    Object.entries(CART_DATA).map((x, y) => {
      const _product = productList[x[1].ItemNumber];
      if (_product?.ObsoleteFlag || _product?.EndOfLifeFlag) {
        system_alert_indicator({
          name: "eol/obsolete",
          message: "This cart contains EOL/Obsolete part.",
          type: "danger",
        });
        if (isErrorEvent) {
          errorDetailsEvent("This cart contains EOL/Obsolete part",CARTEOLOBSOLETE);
          setErrorEvent(false);
        }
      }
      if (_product?.NCNRFlag) {
        system_alert_indicator({
          name: "NCNRFlag",
          message:
            "Your cart contains NCNR: <span>Non-Cancelable/Non-Returnable parts.</span>",
          type: "warning",
        });
      }
      if (_product?.HazardousFlag) {
        system_alert_indicator({
          name: "HazardousFlag",
          message:
            "Hazardous Item: Due to restrictions on transportation of dangerous/hazardous goods, there may be additional transit time on this item. Delivery of other items on your order will be unaffected.",
          type: "warning",
          isDisplay: false,
          isDisplayIcon: true,
        });
      }
      if (x[1].isProductAvailableFromMainAPI === false) {
        system_alert_indicator({
          name: "isProductAvailableFromMainAPI",
          message:
            "You have item(s) in your cart that can no longer be purchased from our site. Please remove item(s) from cart to Checkout.",
          type: "danger",
        });
        if (isErrorEvent) {
          errorDetailsEvent(
            "You have item(s) in your cart that can no longer be purchased from our site. Please remove item(s) from cart to Checkout.",PRODUCT_UNAVAILABLE
          );
          setErrorEvent(false);
        }
      }
    });
  }, [VALIDATE_CART?.validation, productList]);
  function errorDetailsEvent(errMsg,errorName = '') {
    localStorage.setItem("adobeEventType", "errorEvent");
    let errorDetails = {
      errorMSG:  isArray(errMsg) && errMsg[1] || errMsg,
      location: "cartView",
      errorName: isArray(errMsg) && errMsg[0] || errorName,
    };
    if (Object.keys(errorDetails).length) {
      HelperAdobeEvent.trackingAdobeEvent({ errorDetails });
    }
  }

  return (
    <>
      {__check(["CHECKOUT_CALL"]).status && (
        <AxiosIndicatorRunTimeLoader overlay={true} />
      )}
      <div className="col-xl-9">
        <div className="col-12 m1-3">
          <div className="cart-alert">
            <ShowAlert />
          </div>

          {!__check(["CART_API_CALL", "VIEW_CART_API_CALL"]).status &&
            Object.entries(CART_DATA)?.length === 0 && (
              <>
                <FadeInOut
                  show={true}
                  duration={1000}
                  style={{}}
                  className="alert alert-info text-center mb-2"
                >
                  <span>Your Shopping Cart is Empty.</span>
                </FadeInOut>
              </>
            )}
        </div>
        <div className="col-auto mt-3">
          <div className="page-title font-oswald font-light font-38">
            MY CART
          </div>
        </div>
        <CartManuallyAddPart />
        <div className={"pt-2 pb-2"}>
          <ClearCart />
        </div>
        <CartList />
      </div>
    </>
  );
};

export default CartLeftContent;
